
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  // TODO new name?
  name: "BaseSheetHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    usePrimaryColor: {
      type: Boolean,
      default: true,
    },
    content: {
      type: String,
      required: false,
    },
    displayText: {
      type: Boolean,
      default: false,
    },
  },
});
